var exports = {
  "kL": "SegmentedTabs.module__container___SnZUMl",
  "gj": "SegmentedTabs.module__tabList___SnZUMl",
  "Mf": "SegmentedTabs.module__tab___SnZUMl",
  "DF": "SegmentedTabs.module__tabInactive___SnZUMl",
  "yR": "SegmentedTabs.module__tabActive___SnZUMl",
  "KE": "SegmentedTabs.module__tabBackground___SnZUMl",
};

module.exports = exports;
